import React, { useEffect, useRef, useState } from "react";
import {
  StyleSheet,
  Text,
  View,
  TouchableOpacity,
  Dimensions,
  TextInput,
  ScrollView,
  Alert,
} from "react-native";
import Modal from "modal-react-native-web";
import Select from "react-select";
import Dawer from "../../component/drawer";
import Admin from "../../component/admin";
import { Feather } from "@expo/vector-icons";
import TableUser from "./tableuser";
import { apiservice } from "../../service/service";
import { tokenState } from "../../reducer/reducer/reducer/Atom";
import { useRecoilState } from "recoil";
import { useIsFocused } from "@react-navigation/native";

const { width, height } = Dimensions.get("window");
export default function user({ navigation }) {
  const focus = useIsFocused();
  const [token, setToken] = useRecoilState(tokenState);
  const [data, setData] = useState([]);
  const [role, setrole] = useState(null);
  const [search, setsearch] = useState(null);
  const [statuses, setstatuses] = useState(null);
  const [modalGenerateUser, setModalGenerateUser] = useState(false);
  const [generateEmail, setGenerateEmail] = useState("");
  const [generateType, setGenerateType] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [totalPages, setTotalPages] = useState(1);
  const [totalUsers, setTotalUsers] = useState(0);

  async function getalluser(page = 1) {
    if (isLoading) return;

    setIsLoading(true);
    const response = await apiservice({
      path: `/admin/getalluser?page=${page}&limit=20&search=${search || ""}&role=${role?.value || ""}&status=${statuses?.value || ""}`,
      method: "get",
      token: token?.accessToken,
    });

    if (response.status == 200) {
      const newData = response.data.data || [];
      const total = response.data.total || 0;

      setData(newData);
      setTotalUsers(total);
      setTotalPages(Math.ceil(total / 20));

      // Stop if no more data
      if (newData.length < 20) {
        setHasMore(false);
      } else {
        setHasMore(true);
      }
    }

    setIsLoading(false);
  }

  async function generateUser() {
    if (!generateEmail || !generateType) {
      Alert.alert("Error", "Please fill in all fields");
      return;
    }

    const response = await apiservice({
      path: "/admin/generate-user",
      method: "post",
      body: {
        email: generateEmail,
        type: generateType?.value,
      },
      token: token?.accessToken,
    });

    if (response.status == 200) {
      Alert.alert("Success", "User generated successfully");
      setModalGenerateUser(false);
      setGenerateEmail("");
      setGenerateType(null);
      setPageNumber(1);
      getalluser(1);
    } else {
      Alert.alert("Error", response?.data?.message || "Failed to generate user");
    }
  }
  const [items, setItems] = useState([
    { label: "member", value: "member" },
    { label: "VIP", value: "VIP" },
  ]);
  const [items1, setItems1] = useState([
    { label: "Active", value: "Active" },
    { label: "Block", value: "Block" },
  ]);
  const typeOptions = [
    { label: "GOOGLE", value: "GOOGLE" },
    { label: "LINE", value: "LINE" },
    { label: "APPLE", value: "APPLE" },
  ];

  const handleNextPage = () => {
    setPageNumber(prev => prev + 1);
  };

  const handlePrevPage = () => {
    if (pageNumber > 1 && !isLoading) {
      setPageNumber(prev => prev - 1);
    }
  };

  const handleGoToPage = (page) => {
    if (page >= 1 && page <= totalPages && !isLoading) {
      setPageNumber(page);
    }
  };

  useEffect(() => {
    // Reset pagination when filters change
    setPageNumber(1);
  }, [role, statuses]);

  useEffect(() => {
    getalluser(pageNumber);
  }, [focus, pageNumber, role, statuses, search]);

  return (
    <View style={styles.container}>
      <Modal
        animationType="slide"
        transparent={true}
        visible={modalGenerateUser}
        onRequestClose={() => {
          setModalGenerateUser(!modalGenerateUser);
        }}
      >
        <View style={styles.backmodal}>
          <View style={styles.viewmodal}>
            <Text style={styles.textmodaltitle}>Generate User</Text>

            <Text style={styles.textlabel}>Email</Text>
            <TextInput
              value={generateEmail}
              onChangeText={setGenerateEmail}
              placeholder="Enter email"
              style={styles.inputmodal}
            />

            <Text style={styles.textlabel}>Type</Text>
            <Select
              value={generateType}
              onChange={(val) => {
                setGenerateType(val);
              }}
              placeholder="Select type"
              styles={{
                control: (baseStyles, state) => ({
                  ...baseStyles,
                  width: "100%",
                  height: 50,
                  borderWidth: 1,
                  borderColor: "#ccc",
                  borderRadius: 5,
                  fontFamily: "Prompt-Regular",
                  marginBottom: 20,
                }),
              }}
              options={typeOptions}
            />

            <View
              style={{
                flexDirection: "row",
                marginTop: 20,
                alignSelf: "flex-end",
              }}
            >
              <TouchableOpacity
                onPress={() => {
                  setModalGenerateUser(false);
                  setGenerateEmail("");
                  setGenerateType(null);
                }}
                style={styles.touchmodal}
              >
                <Text style={styles.textadd}>Cancel</Text>
              </TouchableOpacity>
              <TouchableOpacity
                onPress={generateUser}
                style={[styles.touchmodal, { marginLeft: 25 }]}
              >
                <Text style={styles.textadd}>Generate</Text>
              </TouchableOpacity>
            </View>
          </View>
        </View>
      </Modal>

      <Dawer navigation={navigation} />
      <ScrollView>
        <View style={styles.back}>
          <Admin />

          <View style={styles.viewfree}>
            <Text style={styles.textfree}>USER({totalUsers})</Text>
            <View style={{ flexDirection: "row", gap: 10 }}>
              <TouchableOpacity
                onPress={() => navigation.navigate("CreateUser")}
                style={styles.touchadd}
              >
                <Text style={styles.textadd}>ADD USER</Text>
              </TouchableOpacity>
            </View>
          </View>
          <View style={styles.viewfil}>
            <Text style={styles.textfil}>FILTERS</Text>
            <View style={{ flexDirection: "row" }}>
              <View>
                <Text style={styles.textfilits}>Role</Text>
                <Select
                  value={role}
                  onChange={(val) => {
                    setrole(val);
                  }}
                  styles={{
                    control: (baseStyles, state) => ({
                      ...baseStyles,
                      borderColor: state.isFocused ? "grey" : "red",
                      width: width * 0.26,
                      height: 30,
                      borderWidth: 1,
                      borderColor: "#ccc",
                      paddingLeft: 10,
                      borderRadius: 5,
                      color: "#777777",
                      fontFamily: "Prompt-Regular",
                      alignSelf: "center",
                      marginRight: 20,
                      zIndex: 9999,
                    }),
                  }}
                  options={items}
                />
              </View>
              <View>
                <Text style={styles.textfilits}>Status</Text>
                <Select
                  value={statuses}
                  onChange={(val) => {
                    setstatuses(val);
                  }}
                  styles={{
                    control: (baseStyles, state) => ({
                      ...baseStyles,
                      borderColor: state.isFocused ? "grey" : "red",
                      width: width * 0.26,
                      height: 30,
                      borderWidth: 1,
                      borderColor: "#ccc",
                      paddingLeft: 10,
                      borderRadius: 5,
                      color: "#777777",
                      fontFamily: "Prompt-Regular",
                      alignSelf: "center",
                      marginRight: 20,
                      zIndex: 9999,
                    }),
                  }}
                  options={items1}
                />
              </View>
              <View>
                <Text style={styles.textfilits}>Search</Text>
                <View style={{ flexDirection: "row" }}>
                  <TextInput
                    placeholder="Search"
                    style={{
                      width: width * 0.26,
                      height: 38,
                      borderWidth: 1,
                      borderColor: "#ccc",
                      paddingLeft: 10,
                      borderRadius: 5,
                      color: "#777777",
                      fontFamily: "Prompt-Regular",
                      alignSelf: "center",
                    }}
                    onChangeText={setsearch}
                  />
                  <TouchableOpacity
                    onPress={() => {
                      setPageNumber(1);
                      getalluser(1);
                    }}
                    style={{ alignSelf: "center", marginLeft: -30 }}
                  >
                    <Feather name="search" size={18} color="black" />
                  </TouchableOpacity>
                </View>
              </View>
            </View>
          </View>
          <TableUser
            navigation={navigation}
            data={data}
          />

          {/* Pagination Controls */}
          <View style={styles.paginationContainer}>
            <TouchableOpacity
              onPress={handlePrevPage}
              disabled={pageNumber === 1 || isLoading}
              style={[
                styles.paginationButton,
                (pageNumber === 1 || isLoading) && styles.paginationButtonDisabled
              ]}
            >
              <Text style={styles.paginationButtonText}>Previous</Text>
            </TouchableOpacity>

            <View style={styles.paginationInfo}>
              <Text style={styles.paginationText}>
                Page {pageNumber}
              </Text>
            </View>

            <TouchableOpacity
              onPress={handleNextPage}
              style={[
                styles.paginationButton,
              ]}
            >
              <Text style={styles.paginationButtonText}>Next</Text>
            </TouchableOpacity>
          </View>
        </View>
      </ScrollView>
    </View>
  );
}
const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: "#F3F3F3",
    flexDirection: "row",
  },
  back: {
    width: "100%",
    height: height,
    paddingHorizontal: "1%",
  },
  viewfree: {
    justifyContent: "space-between",
    width: "100%",
    flexDirection: "row",
  },
  textfree: {
    fontFamily: "Prompt-Regular",
    fontSize: 25,
    color: "#000",
    fontWeight: "bold",
    alignSelf: "center",
  },
  touchadd: {
    width: 150,
    height: 40,
    justifyContent: "center",
    backgroundColor: "#fff",
    alignSelf: "center",
  },
  textadd: {
    fontFamily: "Prompt-Regular",
    fontSize: 24,
    color: "#172B4D",
    alignSelf: "center",
  },
  textfil: {
    fontFamily: "Prompt-Regular",
    fontSize: 18,
    color: "#000",
  },
  textfilits: {
    fontFamily: "Prompt-Regular",
    fontSize: 16,
    color: "#000",
  },
  viewfil: {
    width: "100%",
    backgroundColor: "#fff",
    height: 110,
    borderRadius: 10,
    marginTop: 10,
    padding: 10,
    zIndex: 999,
  },
  backmodal: {
    flex: 1,
    backgroundColor: "#000000bb",
    justifyContent: "center",
  },
  viewmodal: {
    width: width * 0.4,
    backgroundColor: "#fff",
    borderRadius: 5,
    alignSelf: "center",
    padding: 20,
  },
  textmodaltitle: {
    fontFamily: "Prompt-Regular",
    fontSize: 28,
    color: "#000",
    marginBottom: 20,
  },
  textlabel: {
    fontFamily: "Prompt-Regular",
    fontSize: 16,
    color: "#000",
    marginBottom: 5,
  },
  inputmodal: {
    width: "100%",
    height: 50,
    borderWidth: 1,
    borderColor: "#ccc",
    paddingLeft: 10,
    borderRadius: 5,
    color: "#777777",
    fontFamily: "Prompt-Regular",
    marginBottom: 20,
  },
  touchmodal: {
    width: 120,
    height: 40,
    justifyContent: "center",
    borderRadius: 5,
    borderWidth: 0.5,
    borderColor: "#DBDBDB",
  },
  paginationContainer: {
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    marginVertical: 20,
    gap: 20,
  },
  paginationButton: {
    paddingHorizontal: 20,
    paddingVertical: 10,
    backgroundColor: "#fff",
    borderRadius: 5,
    borderWidth: 1,
    borderColor: "#DBDBDB",
    minWidth: 100,
  },
  paginationButtonDisabled: {
    backgroundColor: "#f5f5f5",
    opacity: 0.5,
  },
  paginationButtonText: {
    fontFamily: "Prompt-Regular",
    fontSize: 16,
    color: "#172B4D",
    textAlign: "center",
  },
  paginationInfo: {
    paddingHorizontal: 20,
  },
  paginationText: {
    fontFamily: "Prompt-Regular",
    fontSize: 16,
    color: "#000",
  },
});
